import { Box, Chip } from '@montugroup/design-system';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

type DiscrepancyDirection = 'up' | 'down';

const DISCREPANCY_ICON: Record<DiscrepancyDirection, typeof ArrowUpwardIcon> = {
  up: ArrowUpwardIcon,
  down: ArrowDownwardIcon,
};

const DISCREPANCY_COLOR = {
  up: 'success',
  down: 'error',
} as const satisfies Record<DiscrepancyDirection, string>;

const discrepancyDirection = (discrepancy: number): DiscrepancyDirection => {
  return discrepancy > 0 ? 'up' : 'down';
};

export function StocktakeDiscrepancyBadge({ discrepancy }: { discrepancy: number | undefined }) {
  if (discrepancy === undefined || discrepancy === 0) {
    return <Box sx={{ color: 'text.disabled' }}>—</Box>;
  }
  const direction = discrepancyDirection(discrepancy);
  const Icon = DISCREPANCY_ICON[direction];
  return (
    <Chip
      size="small"
      color={DISCREPANCY_COLOR[direction]}
      icon={<Icon />}
      label={Math.abs(discrepancy)}
      sx={{ fontVariantNumeric: 'tabular-nums' }}
    />
  );
}
